import React, { useState } from 'react';
import RingMark from './RingMark';
import './clubsMotion.css';

/**
 * The first card in MY CLUBS (clubs redesign handoff §2). City Portal and Portal Noir are the
 * rooms you're given; this is the one you make, so it sits in the grid with the rest rather than
 * below it. Cyan at rest, inverted to black-on-cyan under the pointer.
 */
export default function StartClubCard({ onStart }) {
  const [hot, setHot] = useState(false);
  return (
    <article
      onClick={onStart}
      onMouseEnter={() => setHot(true)}
      onMouseLeave={() => setHot(false)}
      data-testid="start-club-card"
      data-portal-to="/clubs/create"
      data-clb-motion
      style={{
        background: hot ? '#000' : '#00FFFF',
        color: hot ? '#00FFFF' : '#000',
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: 18,
        boxSizing: 'border-box',
        cursor: 'pointer',
        transition: 'background-color .2s, color .2s',
        animation: 'clbRise 320ms cubic-bezier(0,0,.2,1) both',
      }}
    >
      <span style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <RingMark size={48} spin={6} inset={3} faceBackground="#000">
          <span style={{ color: '#00FFFF', display: 'flex' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="square">
              <path d="M5 12h14M12 5v14" />
            </svg>
          </span>
        </RingMark>
        <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.2em' }}>START YOUR OWN CLUB</span>
        <span style={{ fontSize: 14, lineHeight: 1.5 }}>Turn your people into members.</span>
      </span>
      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 44, borderRadius: 999, background: '#fff', color: '#000', fontSize: 12, fontWeight: 700, letterSpacing: '0.14em' }}>
        START A CLUB →
      </span>
    </article>
  );
}
